<template>
<section>
     <b-overlay :show="showOverlay" rounded="lg" no-center="true">
        <template #overlay>
            <div class="text-center" style="margin-top: 100px;">
                <p id="cancel-label">{{ csvUploadMessage }}</p>
                <b-button class="btn green-rflocus" size="sm" @click="showOverlay = false">
                    OK
                </b-button>
            </div>
        </template>
    <div class="row">
        <div class="col-12">
            <div class="card-box">

                <div>
                    <b-input-group class="paginate_count" size="sm" :prepend="$t('display')" style="float:left">
                        <b-form-input class="align-middle" v-model="paginateCount">
                        </b-form-input>
                    </b-input-group>

                 

                    <b-input-group v-if="this.title === 'Stocks'" class="paginate_count" size="sm" :prepend="$t('total')" style="float:right">
                        <b-form-input class="align-middle" :modelValue="stockCount" disabled style="width:70px">
                        </b-form-input>
                    </b-input-group>

                    <button v-if="this.title === 'Stocks' && isUpdateFlag" type="button" class="btn btn-secondary"  style="float:right;margin-right:10px" @click="onclickItemCancel">
                        <span>{{$t("cancel")}}</span>
                    </button>

                    <button v-if="this.title === 'Stocks' && isUpdateFlag" type="button" class="btn btn-danger"  style="float:right;margin-right:10px" @click="onclickItemUpdate">
                            <span>{{$t("saveLocationChange")}}</span>
                    </button>

                </div>

                <br>
                <br>

                <b-table class="tablesaw list-container" :busy="loading" bordered :items="items" :fields="fields" striped responsive :select-head="false" :selectable="selectable" @rowSelected="$emit('row-selected', $event)" @rowUnselected="$emit('un-row-selected', $event)" @headClicked="sortChange">


                    <template v-slot:head()="data">
                        <div style="white-space: nowrap">
                            <span>{{ data.label }}</span>
                            <i-bi-caret-down-fill v-if="fields.find(item=> item.label === data.label) === undefined || fields.find(item=> item.label === data.label).sortDirection === undefined" style="visibility: hidden" />
                            <i-bi-caret-up-fill v-else-if="fields.find(item=> item.label === data.label).sortDirection === 'asc'" />
                            <i-bi-caret-down-fill v-else-if="fields.find(item=> item.label === data.label).sortDirection === 'desc'" />
                        </div>

                    </template>

                    <template v-slot:cell(Job.id)="row">
                        <span :class="rowClickAble ? 'number' : null" @click="setModalCreate(row.item)">
                            {{row.item['Job.id']}}
                        </span>
                    </template>

                    <template v-slot:cell(COUNT(JobEpc.epc))="row" class="cursor">
                        <template v-if="row.item['JobDetail.expectAmount'] !== undefined">
                            <span :class="row.value < row.item['JobDetail.expectAmount'] ? 'notenough' : (row.value > row.item['JobDetail.expectAmount'] ? 'overstock':'number')" @click="setModalItem(row.item)">
                                {{row.value}}
                            </span>
                        </template>
                        <template v-else-if="row.item['SUM(JobDetail.expectAmount)'] !== undefined">
                            <span :class="row.value < row.item['SUM(JobDetail.expectAmount)'] ? 'notenough' : (row.value > row.item['SUM(JobDetail.expectAmount)'] ? 'overstock':'number')" @click="setModalItem(row.item)">
                                {{row.value}}
                            </span>
                        </template>
                        <template v-else>
                            <span class="number" @click="setModalItem(row.item)">
                                {{row.value}}
                            </span>
                        </template>
                    </template>

                    <template v-slot:cell(JobDetail.expectAmount)="row" class="cursor">
                        <template v-if="row.item['COUNT(JobEpc.epc)'] !== undefined">
                            <span :class="row.value < row.item['COUNT(JobEpc.epc)'] ? 'notenough1' : (row.value > row.item['COUNT(JobEpc.epc)'] ? 'overstock1':'number1')" >
                                {{row.value}}
                            </span>
                        </template>
                        <template v-else>
                            <span class="number1">
                                {{row.value}}
                            </span>
                        </template>
                    </template>

                    <template v-slot:cell(SUM(JobDetail.expectAmount))="row" class="cursor">
                        <template v-if="row.item['COUNT(JobEpc.epc)'] !== undefined">
                            <span :class="row.value < row.item['COUNT(JobEpc.epc)'] ? 'notenough1' : (row.value > row.item['COUNT(JobEpc.epc)'] ? 'overstock1':'number1')" >
                                {{row.value}}
                            </span>
                        </template>
                        <template v-else>
                            <span class="number1">
                                {{row.value}}
                            </span>
                        </template>
                    </template>

                    <template v-slot:cell(realAmount)="row" class="cursor">
                        <template v-if="row.item['expectAmount'] !== undefined">
                            <span :class="row.value < row.item['expectAmount'] ? 'notenough' : (row.value > row.item['expectAmount'] ? 'overstock':'number')" @click="setModalItem(row.item)">
                                {{row.value}}
                            </span>
                        </template>
                        <template v-else>
                            <span class="number" @click="setModalItem(row.item)">
                                {{row.value}}
                            </span>
                        </template>
                    </template>

                    <template v-slot:cell(expectAmount)="row" class="cursor">
                        <template v-if="row.item['realAmount'] !== undefined">
                            <span :class="row.value < row.item['realAmount'] ? 'notenough1' : (row.value > row.item['realAmount'] ? 'overstock1':'number1')" >
                                {{row.value}}
                            </span>
                        </template>
                        <template v-else>
                            <span class="number1">
                                {{row.value}}
                            </span>
                        </template>
                    </template>

                    <template v-slot:cell(stockAmount)="row" class="cursor">
                        <span class="number" @click="setModalItem(row.item)">
                            {{row.value}}
                        </span>
                    </template>

                    <template v-slot:cell(temiPath)="row" class="cursor">
                        <ButtonAdd v-if="row.item.hasRobotLogFlag" class="create_label"  @click="showRobotPathFun(row.item['Job.id'])">Replay</ButtonAdd>
                    </template>

                    <template v-slot:cell(Stock.warehouseId)="row">
                        <div v-if="locationEditable && row.item.mapEditing === true">
                            <b-form-select v-model="row.value" :options="warehouseOptions" @change="changeItem($event, row.item, row.field.key)"></b-form-select>
                        </div>
                        <div v-else @click="clearLocationFocus(row)" style="cursor: pointer;">
                            {{ row.item['Stock.warehouseId']  || '&nbsp;'  }}
                        </div>
                    </template>

                    <template v-slot:cell(Stock.locationId)="row">
                        <div v-if="locationEditable && row.item.locationEditing === true">
                            <location-picker :key="''+ paginate.current_page + row.index" :index="''+ paginate.current_page + row.index" :modelValue="{label: row.item['Stock.locationId']}" :locationOptions="locationOptions" :lpWareHouseId="resolveWarehouseId(row.item)" @locationInput="changeLocation('Stock.locationId', $event, row.item)"></location-picker>
                        </div>
                        <div v-else @click="clearMapFocus(row)"  style="cursor: pointer;">
                            {{ row.item['Stock.locationId']  || '&nbsp;' }}
                        </div>
                    </template>

                    <template v-slot:cell()="row">
                        <template v-if="row.item['NUMBER'] === row.field.key">
                            <span class="number" @click="setModalItem(row.item)">
                                {{row.value}}
                            </span>
                        </template>
                        <template v-else-if="row.field.key.indexOf('BARCODE(') !== -1">
                            <Barcode :text="row.item[row.field.key.replace('BARCODE(','').replace(')','')]" :index="row.item[row.field.key.replace('BARCODE(','').replace(')','')] + row.index"></Barcode>
                        </template>
                        <template v-else-if="row.field.inputType === 7 && row.value">
                            <template v-for="(part, index) in splitUrlValues(row.value)" :key="index">
                                <a v-if="isLinkablePart(part)" href="#" class="cursor" @click.prevent="openUrlOrImage(part)">{{ part }}</a><span v-else class="cursor">{{ part }}</span><template v-if="index < splitUrlValues(row.value).length - 1">, </template>
                            </template>
                        </template>
                        <template v-else>
                            <span class="cursor">{{ row.value }}</span>
                        </template>
                    </template>
                    

                </b-table>

                <div class="d-flex justify-content-center align-content-center mt-4">
                    <slot name="paginate"></slot>
                </div>

                <slot name="button"></slot>

            </div>
        </div>
    </div>
</b-overlay>
</section>
</template>

<script>
import Paginate from '../ThePaginate.vue'
import moment from 'moment';
import {
    BFormInput,
    BInputGroup,
    BInputGroupText,
    BPagination,
    BTable,
} from "bootstrap-vue-next";
import Barcode from "../barcode/Barcode.vue"
import LocationPicker from "../LocationPicker.vue";
import * as mutations from "../../graphql/locus_mutations";
import {
    API,
    Storage
} from "aws-amplify";

export default {
    props: ['elements', 'loading', 'headers', 'paginate', 'value', 'title', 'sort', 'selectable', 'stockCount', 'rowClickAble', 'listWarehouses', 'locationOptions', 'warehouseId', 'locationEditable', 'url', 'form', 'formItems', 'tenantId'],
    components: {
        Paginate,
        BTable,
        BInputGroup,
        BFormInput,
        BInputGroupText,
        Barcode,
        LocationPicker
    },
    data() {
        return {
            paginateCount: 0,
            isUpdateFlag: false,
            showOverlay: false,
            csvUploadMessage: "",
        }
    },
    filters: {
        moment: function (date) {
            return date ? moment(date).format('YYYY/MM/DD HH:mm:ss') : '';
        },
        momentDay: function (date) {
            return date ? moment(date).format('YYYY/MM/DD') : '';
        }
    },
    watch: {
        elements() {
            this.isUpdateFlag = false
        },
        paginateCount: function () {
            this.$emit('updatePaginateCount', this.paginateCount)
        },
    },
    mounted() {
        this.paginateCount = this.value
    },

    computed: {
        warehouseOptions() {
            return this.listWarehouses.map((item) => ({
                value: item.name,
                text: `${item.name}`,
            }));
        },
        items(){
            return this.elements.map((item) =>{
                var color = {}
                if(item.colorFlag === 1){
                    color = {_rowVariant: 'bg-warning'}
                } else if(item.colorFlag === 2){
                    color = {_rowVariant: 'bg-danger'}
                }
                // Keep edits on the same row object across computed recalculations.
                if (!item.stockEditInitialized) {
                    item.oldWarehouseId = this.resolveWarehouseId(item)
                    item.originalLocationId = item.locationId
                    item.originalStock = item.originalStock || Object.fromEntries(
                        Object.entries(item).filter(([key, value]) =>
                            key.startsWith('Stock.') && value !== undefined &&
                            key !== 'Stock.warehouseId' && key !== 'Stock.locationId')
                    )
                    item.stockEditInitialized = true
                }
                if (item.oldWarehouseId === undefined) {
                    item.oldWarehouseId = this.resolveOriginalWarehouseId(item)
                }
                Object.assign(item, color)
                return item
            })
        },
        fields() {
            let headers = this.headers
                .map((header) => {
                    // header.source must end up matching the row's actual JSON key
                    // exactly, since it's used below as `item[header.source]`. A menu
                    // config can write its own alias in any case (" as "/" AS ") and
                    // wrap it in backticks (e.g. `IF(...) AS \`Stock.locationId2\``,
                    // needed so a dotted name like "Stock.locationId2" is one literal
                    // identifier instead of being parsed as table.column) -- neither
                    // of those survives into the key the backend actually returns, so
                    // both have to be stripped here or the column renders blank.
                    const lowerSource = header.source.toLowerCase()
                    if (lowerSource.includes(" as ")) {
                        header.source = header.source.substring(lowerSource.indexOf(" as ") + " as ".length).trim()
                        if (header.source.startsWith("`") && header.source.endsWith("`")) {
                            header.source = header.source.slice(1, -1)
                        }
                    }

                    let index = 0;
                    if (this.sort.map(sort => sort.source).includes(header.source)) {

                        const direction = this.sort.find((item, i) => {
                            index = i;
                            return item.source === header.source;
                        }).direction === 'asc' ? 'asc' : 'desc';
                        return {
                            id: header.id,
                            key: header.source,
                            name: header.name,
                            index: index,
                            direction: direction,
                            class: ['sorting', "word-break-keep", direction],
                            inputType: header.sourceDefine ? header.sourceDefine.inputType : null,
                        }
                    } else {

                        return {
                            id: header.id,
                            key: header.source,
                            name: header.name,
                            class: ['sorting', "word-break-keep"],
                            inputType: header.sourceDefine ? header.sourceDefine.inputType : null,
                        }
                    }
                })
                .map((item) => {
                    const index = item.index >= 0 ? item.index + 1 : '';
                    return {
                        key: item.key,
                        label: `${item.name}`,
                        thClass: item.class,
                        sortDirection: item.direction,
                        thAttr: {
                            index: index
                        },
                        inputType: item.inputType,
                    }
                });
            return headers;
        }
    },
    methods: {
        // A ケースマーク画像-style URL field can hold several
        // comma-separated entries (multiple photos attached to one row) --
        // each one needs to become its own independent link rather than
        // treating the whole joined string as a single URL/S3 key.
        splitUrlValues(value) {
            if (!value) {
                return []
            }
            return String(value).split(',').map(part => part.trim()).filter(part => part.length > 0)
        },
        // inputType=7 (URL): a value that's already a complete URL (has an
        // explicit http(s):// scheme) opens as-is; otherwise it's treated
        // as an S3 key (already including its own "images/..." etc. path)
        // under this tenant's own public prefix (matching the
        // "public/{tenantId}/..." level convention used elsewhere for
        // warehouse map uploads, see FloorMap.vue's getMap()) and resolved
        // through Storage.get(). Checking for an explicit scheme (rather
        // than guessing from whether the string "looks like" a domain)
        // matters because a bare filename like "a.jpg" also contains a dot
        // and would otherwise be misread as a hostname.
        isCompleteUrl(value) {
            if (!value) {
                return false
            }
            try {
                const parsed = new URL(String(value).trim())
                return parsed.protocol === 'http:' || parsed.protocol === 'https:'
            } catch (error) {
                return false
            }
        },
        // Guesses a MIME type from the filename extension. The S3 object's
        // own stored Content-Type is often wrong or generic (e.g. uploaded
        // as application/octet-stream) -- a browser can't render that
        // inline no matter what Content-Disposition says, and falls back
        // to downloading it. Forcing a real image content type on the
        // presigned URL itself sidesteps whatever the object was actually
        // uploaded with.
        guessImageContentType(value) {
            const match = /\.([a-z0-9]+)$/i.exec(String(value).trim())
            const ext = match ? match[1].toLowerCase() : ''
            const types = {
                jpg: 'image/jpeg',
                jpeg: 'image/jpeg',
                png: 'image/png',
                gif: 'image/gif',
                webp: 'image/webp',
                bmp: 'image/bmp',
                svg: 'image/svg+xml',
            }
            return types[ext] || null
        },
        // A URL-type field can also hold a plain status label with no file
        // at all (e.g. "伝票無し" meaning "no slip attached") rather than a
        // real filename -- rendering that as a link just leads to a raw S3
        // NoSuchKey error page when clicked. Only values that are either a
        // complete URL or look like a real image filename become links;
        // anything else displays as plain text.
        isLinkablePart(value) {
            return this.isCompleteUrl(value) || !!this.guessImageContentType(value)
        },
        async openUrlOrImage(value) {
            if (this.isCompleteUrl(value)) {
                window.open(String(value).trim(), '_blank')
                return
            }
            // window.open() must happen synchronously within the click
            // handler or popup blockers can silently swallow it once an
            // await has passed -- open a blank tab now and navigate it
            // once the presigned URL below is ready.
            const newTab = window.open('', '_blank')
            try {
                // Without contentDisposition, the presigned URL inherits
                // whatever the object was uploaded with (often "attachment"
                // or none, which browsers treat as "download this" rather
                // than "show this"), regardless of how the link itself is
                // opened. Forcing "inline" (and a real contentType, see
                // guessImageContentType above) overrides that on the URL
                // itself, independent of the object's own stored metadata.
                const contentType = this.guessImageContentType(value)
                const options = { contentDisposition: 'inline' }
                if (contentType) {
                    options.contentType = contentType
                }
                const imageUrl = await Storage.get(`${this.tenantId}/${value}`, options)
                if (newTab) {
                    newTab.location.href = imageUrl
                } else {
                    window.open(imageUrl, '_blank')
                }
            } catch (error) {
                console.error(error)
                if (newTab) {
                    newTab.close()
                }
            }
        },
        setModalItem(item) {
            this.$emit('setModalItem', item)
        },
        setModalCreate(item) {
            this.$emit('setModalCreate', item);
        },
        updatePaginateCount(value) {
            this.$emit('updatePaginateCount', value)
        },
        sortChange(sort) {
            this.$emit('sortChange', sort)
        },
        showRobotPathFun(jobId) {
            this.$emit('showRobotPathFun', jobId)
        },
        resolveOriginalWarehouseId(item) {
            return item.oldWarehouseId ?? this.resolveWarehouseId({
                warehouseId: item.originalStock?.['Stock.warehouseId'],
                locationId: item.originalLocationId,
            })
        },
        resolveWarehouseId(item) {
            const isId = value => value !== null && value !== undefined && value !== '' &&
                Number.isInteger(Number(value)) && Number(value) >= 0
            if (isId(item.warehouseId)) return Number(item.warehouseId)
            if (isId(item.locationId)) {
                const location = this.locationOptions.find(location => String(location.id) === String(item.locationId))
                if (location && isId(location.warehouseId)) return Number(location.warehouseId)
            }
            if (isId(this.url.warehouse_id)) return Number(this.url.warehouse_id)
            const filter = this.form['Stock.warehouseId']
            if (isId(filter)) return Number(filter)
            return undefined
        },
        clearLocationFocus(row){
            row.item.mapEditing = true
            row.item.locationEditing = false
        },
        clearMapFocus(row){
            row.item.mapEditing = false
            row.item.locationEditing = true
        },
        changeItem(value, cell, key) {
            cell[key] = value;
            cell.isMapUpdate = true
            this.isUpdateFlag = true
            var currentWareHouse = this.listWarehouses.filter(item => item.name === cell["Stock.warehouseId"])
            if(currentWareHouse.length > 0){
                cell.warehouseId = currentWareHouse[0].id
            }
            cell.isLocationUpdate = false
            cell["Stock.locationId"] = undefined
            cell.locationEditing = false
            this.$forceUpdate();
        },
        changeLocation(key, value, cell) {
            if (value === null || value === undefined) {
                value = ''
            }
            if (typeof value === 'string') {
                if(cell[key] === value){
                    return
                }
                cell[key] = value;
            } else {
                if(cell[key] === value.label){
                    return
                }
                cell[key] = value.label;
            }
            cell.isLocationUpdate = true
            cell.mapEditing = false
            this.isUpdateFlag = true
        },
        async onclickItemUpdate(){
             var updateList = this.items.filter(item => item.isMapUpdate || item.isLocationUpdate)
            if(updateList.length > 0) {
                const update = [];
                
                var myInit = {};
                for (const key in this.form) {
                    const hasKey = this.formItems.some(i => i.options === key)
                    const isDate = this.formItems.some(i => i.sourceDefine && (i.sourceDefine.inputType === 2 || i.sourceDefine.inputType === 4 || i.sourceDefine.inputType === 6) && i.options === key)
                    if (hasKey) {
                        if (this.form[key] !== undefined && this.form[key] !== null && this.form[key] !== '') {
                            //myInit.body[key] = this.form[key]
                            if (typeof (this.form[key]) === "boolean") {
                                if (this.form[key] === true) {
                                    myInit[key] = this.form[key]
                                }
                            } else if (typeof (this.form[key]) == "string" && !isDate) {
                                myInit[key] = "%" + this.form[key] + "%"
                            } else {
                                myInit[key] = this.form[key]
                            }

                        }
                    }
                }

                const requests = []
                for (const element of updateList) {
                    const oldWarehouseId = this.resolveOriginalWarehouseId(element)
                    const warehouses = this.listWarehouses.filter(item => item.name === element['Stock.warehouseId'])
                    const targetWarehouseId = element.isMapUpdate
                        ? (warehouses.length === 1 ? warehouses[0].id : undefined)
                        : oldWarehouseId
                    const locations = this.locationOptions.filter(item =>
                        String(item.warehouseId) === String(targetWarehouseId) &&
                        item.label === element['Stock.locationId'])
                    const hasLocation = element['Stock.locationId'] !== undefined &&
                        element['Stock.locationId'] !== null && element['Stock.locationId'] !== ''
                    if (targetWarehouseId === undefined ||
                        (element.isLocationUpdate && hasLocation && locations.length !== 1)) {
                        this.showOverlay = true
                        this.csvUploadMessage = this.$t('update_error')
                        return
                    }
                    const data = {}
                    if (element.isMapUpdate) {
                        data.warehouseId = targetWarehouseId
                        data.locationId = 0
                    }
                    if (element.isLocationUpdate) {
                        data.locationId = hasLocation ? locations[0].id : 0
                    }
                    const condition = {
                        ...myInit,
                        ...element.originalStock,
                        menuId: this.url.menu_id,
                    }
                    if (oldWarehouseId !== undefined) {
                        condition.warehouseId = oldWarehouseId
                        condition['Stock.warehouseId'] = oldWarehouseId
                    }
                    if (element.originalLocationId !== undefined) {
                        condition['Stock.locationId'] = element.originalLocationId
                    }
                    if(element["Stock.epc"] !== undefined && element["Stock.epc"] !== null && element["Stock.epc"] !== "") {
                        condition["epc"] = element["Stock.epc"]
                    }
                    requests.push({
                        query: mutations.updateStocks2,
                        variables: {
                        data: JSON.stringify(data),
                        condition: JSON.stringify(condition),
                        }
                    });
                }
                // Validate every row before sending any updates.
                requests.forEach(request => update.push(API.graphql(request)))
                return Promise.all(update).then((res) => {
                    var successFlag = true
                    this.showOverlay = true
                    res.forEach(response =>{
                        if(response !== undefined && response.data.updateStock2 !== undefined  && response.data.updateStock2 !== null && response.data.updateStock2 > 0) {
                        } else {
                            successFlag = false
                        }
                    })
                    if(successFlag) {
                        this.isUpdateFlag = false
                        this.csvUploadMessage = this.$t("update_success")
                        this.items.forEach(item=> {
                            item.locationEditing = false
                            item.mapEditing = false
                        })
                        this.$emit('getListData')
                    } else {
                        this.csvUploadMessage = this.$t("update_error")
                    }

                }).catch(() => {
                    this.showOverlay = true
                    this.csvUploadMessage = this.$t('update_error')
                })
            }
        },
        onclickItemCancel(){
            this.$emit('getListData')
            this.isUpdateFlag = false
        }
    }
}
</script>

<style>
/* Busy table styling */
table.b-table[aria-busy='true'] td {
    opacity: 0.7;
}

.sorting {
    cursor: pointer;
    user-select: none
}

.inventoryDeleteItem {
    width: 50px;
}

.inventoryDeleteItem.custom-control {
    padding-left: 2.5rem;
}

.notenough {
    color: red;
    cursor: pointer;
}

.overstock {
    color: #e3c23f;
    cursor: pointer;
}

.number {
    color: #007bff;
    cursor: pointer;
}

.notenough1 {
    color: red;
}

.overstock1 {
    color: #e3c23f;
}

.number1 {
    color: #007bff;
}
.table-bg-danger {
    background-color: #FF8B7B !important
}
.table-bg-warning {
    background-color: #FFCF71 !important
}
.table-bg-danger:nth-child(even)>td {
    --bs-table-color: #4c5667   !important;
    background-color: #FF8B7B !important
}
.table-bg-warning:nth-child(even)>td {
    --bs-table-color: #4c5667   !important;
    background-color: #FFCF71 !important
}
.table-bg-danger:nth-child(odd)>td {
    color: #4c5667   !important;
}
.table-bg-warning:nth-child(odd)>td {
    color: #4c5667   !important;
}

.dropdown-menu {
  z-index: 1050;
  max-height: 300px;
  overflow-y: auto;
}
.list-container {
  overflow: visible;
  position: relative;
  z-index: 1;
  min-height: 300px;
}
</style>
